
import Vant, { setToastDefaultOptions } from 'vant';
import 'vant/lib/index.css';
import { App } from 'vue';
import vNavBar from '@/components/vNavBar.vue';

setToastDefaultOptions({
  wordBreak: 'break-word',
});

export default function setupVant(app: App) {
  app.component('v-nav-bar', vNavBar);
  app.use(Vant);
}
